// no baseURI

// object to store loaded and loading chunks
// undefined = chunk not loaded, null = chunk preloaded/prefetched
// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
var installedChunks = {
	"polyfills": 0
};

__webpack_require__.f.j = (chunkId, promises) => {
		// JSONP chunk loading for javascript
		var installedChunkData = __webpack_require__.o(installedChunks, chunkId) ? installedChunks[chunkId] : undefined;
		if(installedChunkData !== 0) { // 0 means "already installed".

			// a Promise means "currently loading".
			if(installedChunkData) {
				promises.push(installedChunkData[2]);
			} else {
				if(!/^(default\-webpack_sharing_consume_default_(a(ngular(\-(architects_module\-federation(\-runtime_angular\-\-df09f1|_angular\-architec\-d7e863)|oauth2\-oidc_angular\-oauth2\-oidc)|_(c(dk_(c(lipboard_angular_cdk_clipboard|oercion_angular_cdk_coercion|ollections_angular_cdk_collections)|o(bservers_(angular_cdk_observers|private_angular_cdk_observers_private)|verlay_angular_cdk_overlay)|p(latform_angular_cdk_platform|ortal_angular_cdk_portal|rivate_angular_cdk_private)|a11y_angular_cdk_a11y|accordion_angular_cdk_accordion|bidi_angular_cdk_bidi|dialog_angular_cdk_dialog|keycodes_angular_cdk_keycodes|layout_angular_cdk_layout|scrolling_angular_cdk_scrolling|stepper_angular_cdk_stepper|text\-field_angular_cdk_text\-field|tree_angular_cdk_tree)|o(mmon_(angular_common|http_angular_common_http)|re_angular_core))|material_(c(ard_angular_material_card|heckbox_angular_material_checkbox|ore_angular_material_core)|d((atepicker_angular_material_datepick|ivider_angular_material_divid)er|ialog_angular_material_dialog)|s(elect_angular_material_select|lide\-toggle_angular_material_slide\-toggle|nack\-bar_angular_material_snack\-bar)|tool(bar_angular_material_toolbar\-web\-679ba3|tip_angular_material_tooltip)|(button_angular_material_butt|icon_angular_material_ic)on|autocomplete_angular_material_autocomplete|form\-field_angular_material_form\-field|input_angular_material_input|list_angular_material_list|menu_angular_material_menu|progress\-spinner_angular_material_pr\-e5a37f)|((animations_browser_angular_animations_|platform\-browser_angular_platform\-)brows|router_angular_rout)er|forms_angular_forms))|g\-grid\-community_ag\-grid\-community)|moment(\-timezone_builds_moment\-timezone\-with\-data\-10\-y\-933a44|_moment)|r(elex_(co(m(ponent_(ok\-(cancel\-dialog_relex_component_ok\-c\-133e25|do\-cancel\-dialog_relex_component_o\-77e2e7)|relex\-(alert\-confirm\-dialog_relex_comp\-e29135|card_relex_component_relex\-card)|unsaved\-changes_relex_component_unsav\-19b15a)|mon_relex_common)|(nfiguration_relex_configurati|re_common_relex_core_comm)on)|h(elp_(angular_relex_help_angular|common_relex_help_common)|ttp_relex_http)|i18n_i18n\-(helpers_relex_i18n_i18n\-helper|services_relex_i18n_i18n\-service)s|user\-location_core_relex_user\-location_core)|xjs_(operators_rxjs_operator|rxj)s)|tslib_tslib|uuid_uuid)|webpack_sharing_consume_default_(datadog_browser\-(logs_datadog_browser\-logs|rum_datadog_browser\-rum)|angular_core_primitives_di_angular_core_primitives_di\-webpack\-da8972))$/.test(chunkId)) {
					// setup Promise in chunk cache
					var promise = new Promise((resolve, reject) => (installedChunkData = installedChunks[chunkId] = [resolve, reject]));
					promises.push(installedChunkData[2] = promise);

					// start chunk loading
					var url = __webpack_require__.p + __webpack_require__.u(chunkId);
					// create error before stack unwound to get useful stacktrace later
					var error = new Error();
					var loadingEnded = (event) => {
						if(__webpack_require__.o(installedChunks, chunkId)) {
							installedChunkData = installedChunks[chunkId];
							if(installedChunkData !== 0) installedChunks[chunkId] = undefined;
							if(installedChunkData) {
								var errorType = event && (event.type === 'load' ? 'missing' : event.type);
								var realSrc = event && event.target && event.target.src;
								error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
								error.name = 'ChunkLoadError';
								error.type = errorType;
								error.request = realSrc;
								installedChunkData[1](error);
							}
						}
					};
					__webpack_require__.l(url, loadingEnded, "chunk-" + chunkId, chunkId);
				} else installedChunks[chunkId] = 0;
			}
		}
};

// no prefetching

// no preloaded

// no HMR

// no HMR manifest

// no on chunks loaded

// install a JSONP callback for chunk loading
var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
	var [chunkIds, moreModules, runtime] = data;
	// add "moreModules" to the modules object,
	// then flag all "chunkIds" as loaded and fire callback
	var moduleId, chunkId, i = 0;
	if(chunkIds.some((id) => (installedChunks[id] !== 0))) {
		for(moduleId in moreModules) {
			if(__webpack_require__.o(moreModules, moduleId)) {
				__webpack_require__.m[moduleId] = moreModules[moduleId];
			}
		}
		if(runtime) var result = runtime(__webpack_require__);
	}
	if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
	for(;i < chunkIds.length; i++) {
		chunkId = chunkIds[i];
		if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
			installedChunks[chunkId][0]();
		}
		installedChunks[chunkId] = 0;
	}

}

var chunkLoadingGlobal = self["collaborationCloudAppFunction"] = self["collaborationCloudAppFunction"] || [];
chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));